export default "<div class=\"dashboard\">\n    <app-counts></app-counts>\n    <user-list></user-list>\n</div>\n"